import * as actionTypes from './actionTypes';

export const updateMasterBalance=(data)=>{
   return {
      type:actionTypes.UPDATE_MASTER_BALANCE,
      payload:data
   }
}